import { useThemeContext } from "@/react/providers";
import { EmojiRenderer } from "@circle-react-shared/EmojiRenderer";
import { Icon } from "@circle-react-shared/Icon";

export interface LinkIconProps {
  bookmark: any;
}

export const LinkIcon = ({ bookmark }: LinkIconProps) => {
  const { currentAppearance } = useThemeContext();

  return (
    <EmojiRenderer
      className="!h-5"
      emoji={bookmark.emoji}
      appearance={currentAppearance}
      customEmojiUrl={bookmark.custom_emoji_url}
      customEmojiDarkUrl={bookmark.custom_emoji_dark_url}
      emptyIcon={
        <Icon
          className="text-default group-hover:text-dark"
          type="new-tab-link"
          size={16}
        />
      }
    />
  );
};
